import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const styles = (theme: Theme) => createStyles({
	wrapperMain: {
		height: "auto", backgroundColor: theme.palette.common.white, paddingRight: "20px", paddingLeft: "20px", fontSize: "18px"
	},
	borderDefault: {
		border: "1px solid #DDDDDD",
		borderRadius: "5px"
	},
	marginTop10: {
		marginTop: theme.spacing.unit
	},
	marginBottom10: {
		marginBottom: theme.spacing.unit,
		// height:'40px',
		'max-width': '33%',
    'flex-basis': '100%',		
	},
	link: {
		fontSize: "12px",
		color: "#2196F3",
		marginBottom: "20px",
		'&:hover': {
			cursor: 'pointer',
		}
	},
	dynamicInputWidth:{ 
     width:"98%"
	},

	widthContent: {
		// width: "440px"
		// width: "375px"
		width: "100%",
		'& div':{
			'width':'97%',
		},
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	defaultSelect : {
		borderRadius: theme.shape.borderRadius,
		position: 'relative',
		backgroundColor: 'white',
		border: '1px solid #dfdfdf',
		fontSize: 16,
		minWidth: theme.spacing.unit * 3,
		transition: theme.transitions.create(['border-color', 'box-shadow']),
		'&:focus': {
		  borderColor: '#a1a1a1',
		}
	}
});